/* Attribution Service */
import './apps/bankrate-cookie'

/* Tracking Homepage Tile Clicks */
import './rebrand/homepage/tracking'

/* Lazy Loader */
import 'lazysizes'

/* Charting Support for Mortgage & Banking Rates */
import Vue from 'vue'
import OARate from './apps/bankrate-homepage/components/oa-rate-rebrand.vue'
import MultiChart from './apps/bankrate-homepage/components/multi-trends-chart-rebrand.vue'

Vue.component('multi-chart', MultiChart)
Vue.component('oa-rate', OARate)

if (document.querySelector('#multiCharts') !== null) {
  new Vue({
    el: '#multiCharts'
  })
}
